{
  "name": "resreq",
  "version": "1.4.3",
  "description": "Fetch-based onion model http client.",
  "main": "dist/index.js",
  "type": "module",
  "scripts": {
    "dev": "tsup src/index.ts --dts --format esm --sourcemap --watch",
    "build": "tsup src/index.ts --dts --format esm --sourcemap --clean",
    "lint": "eslint src __tests__ --ext .js,.ts --fix",
    "tsc": "tsc --noEmit",
    "docs": "typedoc src/index.ts",
    "test": "vitest run --coverage",
    "prepare": "husky install"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "keywords": [
    "fetch",
    "request",
    "requests",
    "http",
    "https",
    "fetching",
    "get",
    "url",
    "curl",
    "wget",
    "net",
    "network",
    "ajax",
    "api",
    "rest",
    "xhr",
    "browser",
    "got",
    "axios",
    "node-fetch"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/molvqingtai/resreq.git"
  },
  "author": "molvqingtai",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/molvqingtai/resreq/issues"
  },
  "homepage": "https://github.com/molvqingtai/resreq#readme",
  "devDependencies": {
    "@commitlint/cli": "^18.4.3",
    "@commitlint/config-conventional": "^18.4.3",
    "@koa/cors": "^5.0.0",
    "@koa/router": "^12.0.1",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/git": "^10.0.1",
    "@types/koa": "^2.13.12",
    "@types/koa__cors": "^5.0.0",
    "@types/koa__router": "^12.0.4",
    "@types/node": "^20.10.5",
    "@typescript-eslint/eslint-plugin": "^6.16.0",
    "@typescript-eslint/parser": "^6.16.0",
    "@vitest/coverage-c8": "^0.33.0",
    "@vitest/coverage-v8": "^1.1.0",
    "@vitest/ui": "^1.1.0",
    "c8": "^8.0.1",
    "eslint": "^8.56.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-config-standard": "^17.1.0",
    "eslint-config-standard-with-typescript": "^43.0.0",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-n": "^16.6.0",
    "eslint-plugin-node": "^11.1.0",
    "eslint-plugin-prettier": "^5.1.2",
    "eslint-plugin-promise": "^6.1.1",
    "husky": "^8.0.3",
    "koa": "^2.15.0",
    "koa-body": "^6.0.1",
    "prettier": "^3.1.1",
    "semantic-release": "^22.0.12",
    "tsup": "^8.0.1",
    "typedoc": "^0.25.4",
    "typescript": "^5.3.3",
    "vite": "^5.0.10",
    "vitest": "^1.1.0"
  },
  "publishConfig": {
    "access": "public"
  }
}
